export class ChangeGatewayInputDto {
    // não grava nada: devolve o que aconteceria, para a tela avisar antes de confirmar
    simulation?: boolean
    gatewayId: string
}

export class ChangeGatewayOutputDto {
    simulation: boolean
    fromGatewayId: string
    toGatewayId: string
    purchaseMethod: string
    purchaseType: string
    // parcelas ainda não enviadas: são estas que passam a cobrar no gateway novo
    chargesToMove: { chargeId: string; dueDate: Date; value: number }[]
    // cobranças já emitidas e ainda pagáveis no gateway anterior
    openAtPreviousGateway: { chargeId: string; dueDate: Date; paymentMethod: string }[]
    // agendadas para nova tentativa num gateway onde já têm pedido: seguem sendo cobradas lá
    retryingAtPreviousGateway?: { chargeId: string; dueDate: Date; gatewayId: string }[]
}
